export const ROLES = {
  admin: "Okta_OSO_Admin",
  planner: "Okta_OSO_Planner",
  mac: "Okta_OSO_MAC",
  member: "Okta_OSO_Member",
  guest: "Okta_OSO_Guest",
};

export const SCOPES = {
  canCreate: "can-create",
  canEdit: "can-edit",
  canDelete: "can-delete",
  canView: "can-view",
  canAll: "can-all", // Note: this scope is only for admin role. e.g. header and routes restrictions
};

export const PERMISSIONS = {
  [ROLES.guest]: [SCOPES.canView],
  [ROLES.member]: [SCOPES.canView],
  [ROLES.mac]: [
    SCOPES.canView,
    SCOPES.canEdit,
    SCOPES.canCreate,
    SCOPES.canDelete,
  ],
  [ROLES.planner]: [
    SCOPES.canView,
    SCOPES.canEdit,
    SCOPES.canCreate,
    SCOPES.canDelete,
  ],
  [ROLES.admin]: [
    SCOPES.canAll,
    SCOPES.canView,
    SCOPES.canEdit,
    SCOPES.canCreate,
    SCOPES.canDelete,
  ],
};
